import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumVolumeUnit implements BaseEnumType {
  private static allValues: EnumVolumeUnit[] = []; // make sure this is top-most
  
  public static none = new EnumVolumeUnit(0, "None", "enum_volume_unit_none");
  public static metricLitre = new EnumVolumeUnit(1, "MetricLitre", "enum_volume_unit_metric_litre");
  public static metricHectolitre = new EnumVolumeUnit(2, "MetricHectolitre", "enum_volume_unit_metric_hectolitre");
  public static usGallon = new EnumVolumeUnit(3, "UsGallon", "enum_volume_unit_us_gallon");
  public static usBeerBarrel = new EnumVolumeUnit(4, "UsBeerBarrel", "enum_volume_unit_us_beer_barrel");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumVolumeUnit.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumVolumeUnit.none; }
  public isMetricLitre() { return this === EnumVolumeUnit.metricLitre; }
  public isMetricHectolitre() { return this === EnumVolumeUnit.metricHectolitre; }
  public isUsGallon() { return this === EnumVolumeUnit.usGallon; }
  public isUsBeerBarrel() { return this === EnumVolumeUnit.usBeerBarrel; }

  public static getValues(): readonly EnumVolumeUnit[] {
    return EnumVolumeUnit.allValues;
  }

  public static getValuesExcept0(): readonly EnumVolumeUnit[] {
    return EnumVolumeUnit.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumVolumeUnit {
    const found = EnumVolumeUnit.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumVolumeUnit - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumVolumeUnit): EnumVolumeUnit {
    const found = name ? EnumVolumeUnit.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumVolumeUnit - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumVolumeUnit>): boolean {
    return this.key === other?.key;
  }
}